import { createAsyncThunk } from "@reduxjs/toolkit";
import { getHeaders, 
  getCourseModules,
  addCourseModules as postCourseModules,
  updateCourseModules as putCourseModules,
  deleteCourseModules as removeCourseModules,
  toggleCourseModule
} from "../../helpers/fakebackend_helper";
import { toast } from "react-toastify";
import { t } from "i18next";


// Fetch Table Column Names
export const fetchCourseModulesTableColumnNames = createAsyncThunk("modules/fetchTableColumnNames", async (module, thunkAPI) => {
    try {
      const response = await getHeaders(module); 
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Fetch All Courses
export const fetchAllCourseModules = createAsyncThunk("modules/fetchAll", async (module, thunkAPI) => {
    try {
      const response = await getCourseModules(module); 
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Add Course
export const createCourseModules = createAsyncThunk("modules/add", async (module, thunkAPI) => {  
    try {
        const response = await postCourseModules(module);
        toast.success(t(response.message));
        return response;
    } catch (error) {
        toast.error(error.message);
        return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Update Course
export const updateCourseModules = createAsyncThunk("modules/update", async (module, thunkAPI) => {
    try {
        const response = await putCourseModules(module);
        toast.success(t(response.message));
        return response.data;
    } catch (error) {
        toast.error(error.message);
        return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Delete Course
export const deleteCourseModules = createAsyncThunk("modules/delete", async (module, thunkAPI) => {
    try {
        const response = await removeCourseModules(module);
        toast.success(t(response.message));
        return response.data;
    } catch (error) {
        toast.error(error.message)
        return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Active deactive Course 
export const activateDeactivateCoursesModule = createAsyncThunk("coursesModule/activateDeactivate", async (course, thunkAPI) => {
    try {
      const response = await toggleCourseModule(course);
      toast.success(t(response.message));
      return response.data;
    } catch (error) {
      toast.error(error.message)
      return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
  });